import gql from 'graphql-tag'

const upgradeTypeMutation = gql`
  mutation SetUpgradeType($upgradeType: String!) {
    setUpgradeType(upgradeType: $upgradeType) @client
  }
`

export default upgradeTypeMutation
